import React from 'react';
import MetricRegistry from './registry/MetricRegistry';
import MetricCard from './cards/MetricCard';
import PresetSelector from './PresetSelector';

const DashboardHome = ({ pinnedCards, onTogglePin, appliedPreset, onApplyPreset, onReset, loaded }) => {
  if (!loaded) {
    return <div className="text-lightgray">Loading preferences...</div>;
  }

  // Order pinned cards by registry definition order (Object.keys preserves insertion order)
  const registryOrder = Object.keys(MetricRegistry);
  const orderedPinned = registryOrder.filter((id) => pinnedCards.includes(id));

  return (
    <div>
      <PresetSelector
        appliedPreset={appliedPreset}
        onApplyPreset={onApplyPreset}
        onReset={onReset}
      />
      {orderedPinned.length === 0 ? (
        <p className="text-lightgray text-sm">No cards pinned. Select a preset or pin cards from category views.</p>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '1.5rem',
          }}
        >
          {orderedPinned.map((metricId) => (
            <MetricCard
              key={metricId}
              metricId={metricId}
              isPinned={true}
              onTogglePin={onTogglePin}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardHome;
